var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficialWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6ZM3.99817 9C3.99817 8.44772 4.44588 8 4.99817 8H27.0021C27.5544 8 28.0021 8.44771 28.0021 9V27C28.0021 27.5523 27.5544 28 27.0021 28H4.99817C4.44588 28 3.99817 27.5523 3.99817 27V9ZM5.15254 6.75C5.84289 6.75 6.40254 6.19036 6.40254 5.5C6.40254 4.80964 5.84289 4.25 5.15254 4.25C4.46218 4.25 3.90254 4.80964 3.90254 5.5C3.90254 6.19036 4.46218 6.75 5.15254 6.75ZM10.4025 5.5C10.4025 6.19036 9.84289 6.75 9.15254 6.75C8.46218 6.75 7.90254 6.19036 7.90254 5.5C7.90254 4.80964 8.46218 4.25 9.15254 4.25C9.84289 4.25 10.4025 4.80964 10.4025 5.5ZM13.7541 4.5C13.2018 4.5 12.7541 4.94772 12.7541 5.5C12.7541 6.05228 13.2018 6.5 13.7541 6.5L26.676 6.5C27.2283 6.5 27.676 6.05228 27.676 5.5C27.676 4.94771 27.2283 4.5 26.676 4.5L13.7541 4.5Z",
    fill: "#56769A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialWeb);
export default __webpack_public_path__ + "static/media/official_web.c1ce9ea11b26faef9330205827b028f9.svg";
export { ForwardRef as ReactComponent };